import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { UserContactListService } from 'app/modules/contacts/services/user-contact-list.service';
import { UserListContainerService } from 'app/modules/configuration/user-list-page/user-list-container/user-list-container.service';
import { AsideService } from 'app/layout/components/aside-container/aside.service';
import { ReactiveFormHelperService } from 'app/shared/helpers/reactive-form-helper.service';
import { LookupList } from 'app/shared/models/lookup-list.model';
import { AuthService } from 'app/core/security/auth/auth.service';
import { ApiAuthService } from 'app/core/security/api/api-auth.service';
import { AuthResponse } from 'app/core/security/api/auth-response.model';
import { CookieService } from 'app/shared/services/cookie.service';
import { CompanyContactFormModel } from 'app/modules/contacts/models/company-contact-form.model';
import { UsersService } from 'app/modules/user-management/services/users.service';
import { SwitchCompanyModel } from './switch-company.model';
import { UserCompanyLookupDataModel } from 'app/modules/contacts/models/user-company-lookup-data.model'
import { CompanyProductListService } from 'app/modules/my-services/services/company-product-list.service';
import { Router } from '@angular/router';



@Component({ standalone: false,
  selector: 'switch-company',
  templateUrl: './switch-company.component.html'
})
export class SwitchCompanyComponent implements OnInit {

  public data: any;

  userContactsLookupData: any[] = [];

  isError: boolean;
  dataForm: FormGroup;
  switchErrorMessage: string;
  currentSelectedMainContactId: number;
  companiesList: LookupList;


  constructor(private fb: FormBuilder,
    private asideService: AsideService,
    private contactService: UserContactListService,
    private userService: UsersService,
    private userListService: UserListContainerService,
    private auth: AuthService,
    private apiAuth: ApiAuthService,
    private cookieService: CookieService,
    private formHelperService: ReactiveFormHelperService,
    private companyProductListService: CompanyProductListService,
    private router: Router) {
    this.dataForm = fb.group({
      companyContactId: ['', [Validators.required]],
    });
  }

  get companyContactId(): AbstractControl {
    return this.dataForm.controls['companyContactId'];
  }

  ngOnInit() {
    this.contactService.getUserCompanyLookupData().then((response: UserCompanyLookupDataModel) => {
      this.companiesList = response.companyList;
      this.currentSelectedMainContactId = response.currentSelectedMainContactId;
      this.initialiseForm();
    });
  }

  initialiseForm() {
    this.userContactsLookupData = this.formHelperService.createLookupDataWithDataObject(this.companiesList);
    this.initialiseDropDown();
  }

  initialiseDropDown() {
    var index = this.companiesList.items.findIndex(x => x.id == this.currentSelectedMainContactId);

    if (this.userContactsLookupData.length >= 1 && this.currentSelectedMainContactId != null) {
      this.companyContactId.setValue(this.userContactsLookupData[index].id);
    }
    else {
      this.companyContactId.setValue(this.userContactsLookupData[0].id);
    }
  }

  switchCompany() {
    if (this.companyContactId.value != this.currentSelectedMainContactId) {
      const updateModel = this.createUpdateModel();
      this.userListService.updateCompanyItem(this.data.userId, updateModel).then((response: any) => {
        if (response.success == true) {
          this.auth.loginWithToken(this.apiAuth.refreshToken).then((response: AuthResponse) => {
            this.handleLoginResponse(response);
            this.asideService.close();
          });
        }
      });
    }
    else {
      this.asideService.close();
    }
  }

  private createUpdateModel() {
    return new SwitchCompanyModel(
      this.companyContactId.value
    )
  }

  private handleLoginResponse(response: AuthResponse) {
    if (response.isError) {
      this.handleRefreshError(response);
    } else {
      this.handleRefreshSuccess(response);
    }
  }

  private handleRefreshError(response: AuthResponse) {
    this.isError = response.isError;
    this.setErrorMessage(response.errorMessage);
  }

  private setErrorMessage(errorMessage: string) {
    this.switchErrorMessage = errorMessage;
  }

  private handleRefreshSuccess(response: AuthResponse) {
    this.auth.loggedInCompanyName = response.data['selectedCompanyName'];
    this.auth.loggedInCompanyId = response.data['selectedCompanyId'];
    this.auth.loggedInCompanyinboundRoutingNumber = response.data['inboundRoutingNumber'];
    this.auth.loggedInContactName = response.data['contactName'];
    this.cookieService.setLoggedInCompanyName(this.auth.loggedInCompanyName);
    this.cookieService.setLoggedInCompanyInboundRoutingNumber(this.auth.loggedInCompanyinboundRoutingNumber);
    this.cookieService.setKeyLoggedInCompanyId(this.auth.loggedInCompanyId);
    this.cookieService.setLoggedInContactName(this.auth.loggedInContactName);

    this.companyProductListService.companyId = this.auth.loggedInCompanyId;
    this.companyProductListService.getCompanyProductList().then((value) => {
      if (value.length == 0) {
        const redirectUrl = 'hub';
        this.router.navigate([redirectUrl]);
      }
    });
  }

  cancel() {
    if (this.isError)
      this.asideService.close("error");
    else
      this.asideService.close("cancel");
  }

}